import { v3ApiClient } from './clients/v3ApiClient';

export interface McpConsentInfo {
  client_name: string;
  client_scopes: string[];
  authorize_url: string;
}

/**
 * Support calls for the MCP OAuth consent page (/mcp/consent). Both ride the
 * session-authenticated v3 client on the API origin — the page never talks to
 * the MCP server directly (no CORS surface), and the authorize URL comes from
 * this trusted channel rather than a query param an attacker could point at
 * their own host.
 */
const getConsentInfo = async (clientId: string) => {
  const response = await v3ApiClient.get<McpConsentInfo>(
    `mcp/consent-info?client_id=${encodeURIComponent(clientId)}`,
  );
  return response.data;
};

/**
 * Mints the single-use (~15s TTL) login-handoff key for the CURRENT session's
 * user; the consent page appends it to the authorize redirect as `oauth_key`.
 */
const generateOauthKey = async () => {
  const response = await v3ApiClient.post<{ key: string }>('authtoken/generate-oauth-key', {});
  return response.data.key;
};

export default { getConsentInfo, generateOauthKey };
